import React, { Component,  useState, useEffect  } from 'react';
import './EstruturaTO5.css';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import holos from '../../assets/videos/holos.mp4';
import interativo2Ativo1 from '../../assets/svgs/interativoAtivo 1.svg';        
import Dt2 from "../../assets/fundos/Dt2.jpg";
import controleremoto from '../../assets/svgs/Controle-01.svg';      
import $, { when } from "jquery";
import { debounce, throttle } from 'lodash';
import seta from '../../assets/svgs/more-white.svg';   

class EstruturaTO5 extends Component {
    componentDidMount() {

        if(window.matchMedia("(max-width: 600px)").matches){
    
        }
        else{
          if($( ".magazinenova" ).mousemove=true){
            $( ".magazinenova" ).mousemove(function( event ) {
     
              $("#TO5desapa").fadeIn();
        
              
            });
          }
          else{
            $("#TO5desapa").fadeOut();
    
          }
    
        }
    
    
    
        $("#TO5dimensao").click(function()
        
        {

          $(".sidebar-wrapper").removeClass("show-sidebar", 500);
          $(".menuuu").addClass("todonone");
          $(".ffechar").addClass("todonone", 500);

          $("#TO5video").prop('muted', false);
          $("#TO5dimensao").addClass("todonone");
          $("#TO5dimensao2").removeClass("todonone");
          $("#TO5desapa2").addClass("todonone");
          $("#TO5video").addClass("pulo");

          $("#TO7dimensao").removeClass("todonone");
          $("#TO7desapa2").removeClass("todonone");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7obra1").removeClass("pulo");
          $("#TO7video").removeClass("pulo");
          $("#TO7local1").removeClass("pulo");
          $("#TO7video").prop('muted', true);

          $("#TO6dimensao").removeClass("todonone");
          $("#TO6desapa2").removeClass("todonone");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6obra1").removeClass("pulo");
          $("#TO6video").removeClass("pulo");
          $("#TO6local1").removeClass("pulo");
          $("#TO6video").prop('muted', true);

          $("#TO8dimensao").removeClass("todonone");
          $("#TO8desapa2").removeClass("todonone");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8obra1").removeClass("pulo");
          $("#TO8video").removeClass("pulo");
          $("#TO8local1").removeClass("pulo");
          $("#TO8video").prop('muted', true);

          $("#TO4dimensao").removeClass("todonone");
          $("#TO4desapa2").removeClass("todonone");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4obra1").removeClass("pulo");
          $("#TO4video").removeClass("pulo");
          $("#TO4local1").removeClass("pulo");
          $("#TO4video").prop('muted', true);

          $("#TO3dimensao").removeClass("todonone");
          $("#TO3desapa2").removeClass("todonone");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3obra1").removeClass("pulo");
          $("#TO3video").removeClass("pulo");
          $("#TO3local1").removeClass("pulo");
          $("#TO3video").prop('muted', true);

          $("#TO2dimensao").removeClass("todonone");
          $("#TO2desapa2").removeClass("todonone");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2obra1").removeClass("pulo");
          $("#TO2video").removeClass("pulo");
          $("#TO2local1").removeClass("pulo");
          $("#TO2video").prop('muted', true);

          $("#dimensao").removeClass("todonone");
          $("#desapa2").removeClass("todonone");
          $("#obra1").removeClass("pulo");
          $("#obra1").removeClass("pulo");
          $("#video").removeClass("pulo");
          $("#local1").removeClass("pulo");
          $("#video").prop('muted', true);
      
    
        }
        );
        $("#TO5dimensao2").click(function()
        
        {
          $(".menuuu").removeClass("todonone");
          $("#TO5video").prop('muted', true);
          $("#TO5dimensao2").addClass("todonone");
          $("#TO5dimensao").removeClass("todonone");
          $("#TO5desapa2").removeClass("todonone");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5obra1").removeClass("pulo");
          $("#TO5video").removeClass("pulo");
          $("#TO5local1").removeClass("pulo");
        }
        );
    
    
        $("#TO5magazinenova").click(function(){
          $("#TO5desapa").delay('slow').fadeIn();
            
        
    
          setTimeout(
            function() 
            {
    
              
              var desaparecendo = 'todonone';
             
              $("#TO5desapa").fadeOut();
            }, 30000);
    
        });
    
        (function () {
    
          $("#TO5botomenu").click(function () {
            $( this ).slideUp().fadeOut(10000);
            $("#TO5hold1 ").addClass("cc");
            $("#TO5botoobras ").addClass("cc");
            $("#TO5hold3 ").addClass("cc");
            $("#TO5hold4 ").addClass("cc");
            $("#TO5hold5 ").addClass("cc");
            $("#TO5hold1 ").removeClass("transiopaca");
            $("#TO5botoobras ").removeClass("transiopaca");
            $("#TO5hold3 ").removeClass("transiopaca");
            $("#TO5hold4 ").removeClass("transiopaca");
            $("#TO5hold5 ").removeClass("transiopaca");
            setTimeout(function(){
              setTimeout(function(){
                $("#TO5hold5 ").addClass("transiopaca");
                setTimeout(function(){
                  $("#TO5hold4 ").addClass("transiopaca");
                  setTimeout(function(){
                    $("#TO5hold3 ").addClass("transiopaca");
                    setTimeout(function(){
                      $("#TO5botoobras ").addClass("transiopaca");
                      $("#TO5hold1 ").addClass("transiopaca");
                      setTimeout(function(){
                        $("#TO5hold1 ").removeClass("cc");
                        $("#TO5botoobras ").removeClass("cc");
                        $("#TO5hold3 ").removeClass("cc");
                        $("#TO5hold4 ").removeClass("cc");
                        $("#TO5hold5 ").removeClass("cc");
                        $("#TO5botomenu").slideDown();
                      },1000);
                    },1000);
    
    
                  },1000);
    
    
                },1000);
    
              },1000);
    
    
    
    
    
    
    
              }, 3000);
    
          });
    
          var qua = $('.resposta');
          var $target = $('.gatilhoObra'),
            animationClass = 'respostaGatilho',
            animationClass2 = 'respostaGatilho2',
            offset = $(window).height() * 1 / 10;
    
    
    
          function animeScroll() {
            $("#TO5desapa").fadeOut();
            
        
    
            setTimeout(
              function() 
              {
                var desaparecendo = 'todonone';
            
                $("#TO5desapa").fadeIn();
              }, 2000);
    
    
            var documentTop = $(document).scrollTop();
    
            $target.each(function (index) {
    
              var itemTop = $(this).offset().top;
    
              if (documentTop > itemTop - offset) {
                $("#TO5botoobras").addClass(animationClass2);
                
              }
              else{
                $("#TO5boto" + index).removeClass(animationClass);
                  
              }
    
              if (documentTop > itemTop - offset) {
                $("#TO5boto" + index).addClass(animationClass);
                
                if (documentTop > itemTop * 2 - offset * 2) {
                  $("#TO5boto" + index).removeClass(animationClass);
                  
                }
                if (documentTop > itemTop){
                  $("#TO5boto" + index).removeClass(animationClass);
                  
                }
              }
            }
    
            
    
            );
          }
    
         
    
          $(document).scroll(debounce(function () {
            animeScroll();
          }, 200));
        })();
    
    
        $('.bolinhas a[href^="#TO5"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
    
        $('.grandeMenu a[href^="#TO5"]').on('click', function (e) {
          e.preventDefault();
          var id = $(this).attr('href'),
            targetOffset = $(id).offset().top;
    
          $('html, body').animate({
            scrollTop: targetOffset - 0
          }, 500);
        });
      }
    render() {
        return (
            <div id="TO5obra1" className="displayTO5 gatilhoObra"> {this.props.children}
                <div id="TO5local1"className="videolocalTO5" style={{backgroundImage: 'url(' + {Dt2} +')'}}>
                <div class="sidebar-wrapper">
                        <div class="sidebar">
                            <h3>2018   </h3>
                            <h2 class="sidebar-titulo proholo">HOLOSCI(U)DAD(E)  </h2>
                            <p class="descricao">Intervenção performance em  um paredão goiano acompanhada de projeção de imagens com a participação do grupo Orquestra de Laptops da UnB. Propõe a invenção de um lugar utópico, multifacetado e em transformação. A trilha sonora é processada em tempo real a partir de frases sonoras que combinam-se e desdobram-se em constante mutação e hibridização. Os sons foram captados pelos artistas do projeto ibero-americano HOLOS, a partir de  contextos sonoros oriundos do Brasil, Espanha, Uruguai, Colômbia e China.  </p>
                            <a className="botaops"  href="https://holousciudade.netlify.app/">obra interactiva</a>
                        </div>
                        <div class="menuuu" id="menuuu"><i class="fa fa-bars fa-2x">
                        <img className="ring button" src={seta} alt=""/>
                        
                            
                            
                            
                            
                            </i></div>
                    </div>
 
 
 
 
 
                    <div className="tampavideoTO5">
                    </div>
                    <div className="ffechar todonone">
                       <i> FECHAR </i>
                    </div>
                    <div className="videoTO5" >
                        <video controlsList = "nofullscreen nodownload noremoteplayback" poster="a" id="TO5video" playsInline autoPlay muted loop>
                            <source src={holos} type="video/mp4">
                            </source>
                        </video>
                    </div>
                    <div className="sobrepo1TO5"></div>
                    <div className="sobrepo2TO5"></div>
                    <div className="sobrepo3TO5"></div>
                </div>
                <div id="TO5desapa" className="magazineTO5">

                
                </div>
                <div className="magazinenova" id="TO5magazinenova">
                    <div id="TO5dimensao"className="controleremoto">
                        <img src={controleremoto} alt=""/>
                    </div>
                    <div id="TO5dimensao2"className="controleremoto2 todonone">
                    <img src={controleremoto} alt=""/>
                        
                </div>
                </div>
            </div>
        );
    }
}
 
export default EstruturaTO5  ;